import React, { useEffect, useState, useRef } from 'react';
interface LazySectionProps {
  children: React.ReactNode;
  fallback?: React.ReactNode;
  rootMargin?: string;
  id?: string;
}
export function LazySection({
  children,
  fallback = <div className="h-64 bg-gray-100 animate-pulse rounded-lg" data-id="element-5727" data-mp="2927ngcycjshn"></div>,
  rootMargin = '100px',
  id
}: LazySectionProps) {
  const [isVisible, setIsVisible] = useState(false);
  const ref = useRef<HTMLDivElement>(null);
  useEffect(() => {
    const observer = new IntersectionObserver(([entry]) => {
      if (entry.isIntersecting) {
        setIsVisible(true);
        observer.disconnect();
      }
    }, {
      rootMargin
    });
    if (ref.current) {
      observer.observe(ref.current);
    }
    return () => {
      observer.disconnect();
    };
  }, [rootMargin]);
  return <div ref={ref} data-id="element-5728" data-mp="1gbph932btb00">{isVisible ? children : fallback}</div>;
}